import React from 'react';
import { Table } from 'react-bootstrap';
import Row from "./components/Row";

const AdkBlockTable = ({ report, partners, onSortChange, onRemove }) => {
    const rows = report.map((row, index) => (<Row {...row} key={index} partners={partners} onRemove={onRemove}/>));

    return (
        <Table bordered responsive style={{ textAlign: 'center', verticalAlign: 'middle' }}>
            <thead>
                <tr>
                    <th onClick={() => onSortChange('date')}>Day</th>
                    <th onClick={() => onSortChange('partner')}>Partner</th>
                    <th onClick={() => onSortChange('subid')}>Subid</th>
                    <th>Action</th>
                </tr>
            </thead>
            <tbody>
                {rows}
            </tbody>
        </Table>
    )
};

export default AdkBlockTable;


// WEBPACK FOOTER //
// ./src/scenes/AdkPartnerBlock/components/Table/index.js